import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencySymbolPipe } from '@common/pipes/currency-symbol.pipe';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule, CurrencySymbolPipe],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  icon = input<string>();
  title = input.required<string>();
  titleFontSize = input<string>('1.125rem');
  titleFontWeight = input<string>('500');
  backgroundColor = input.required<string>();
  color = input.required<string>();
  isDescriptionShown = input<boolean>();
  border = input<string>();
  errorMessage = input<string>();
  padding = input<string>();
  width = input<string>();
  justifyContent = input<string>();
  currency = input<string>('');
  totalValue = input<string>('');
}
